<compartido-ficha [configuracion]="configFicha">
  <compartido-tabla-asincrona
    #tabla
    class="tabla {{ responsiveService.claseCSS$ | async }}"
    [dataSource]="dataSource"
    [configuracion]="configTabla"
    (clickAccion)="prepararOrden$($event.fila['id'])"
  ></compartido-tabla-asincrona>

  <div class="resumen">
    <p>
      Preparadas Hoy:
      <span *ngIf="!cargando()">{{ preparadas() }}</span>
      <mat-spinner
        *ngIf="cargando()"
        diameter="13"
        class="cargando"
      ></mat-spinner>
    </p>

    <div class="accion">
      <p>Etiquetas en este lote: {{ etiquetas.length }}</p>

      <button
        mat-flat-button
        color="primary"
        [disabled]="etiquetas.length === 0 || cargando()"
        [class.cargando]="cargando()"
        (click)="generarEtiquetas()"
      >
        Generar Etiquetas<mat-icon>receipt_long</mat-icon>
      </button>
    </div>
  </div>
</compartido-ficha>
